import type { KeyboardEvent } from "react";

// Make non-button clickable elements keyboard-activatable. Pair with
// `tabIndex={0}` and `role="button"`.
export function activateOnKey<T extends Element>(
  e: KeyboardEvent<T>,
  fn: () => void,
) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    fn();
  }
}
